<script setup lang="ts">
import { AccommodationSelector } from '@apps/main/new-desktop/modules/accommodationSelector';
import { useStatsigEventsStore } from '@apps/main/new-desktop/core/stores';

import type { ItineraryOwnStaySegment } from '../../../models/itinerarySegments/ownStay';
import ItineraryTimeline from '../ItineraryTimeline.vue';
import { useTripOverviewPageStore } from '../../../stores';
import AddHotelBanner from '../AddHotelBanner.vue';

interface ItineraryOwnStaySegmentProps {
  segment: ItineraryOwnStaySegment;
}
const props = defineProps<ItineraryOwnStaySegmentProps>();

const statsigEventsStore = useStatsigEventsStore();
const tripOverviewPageStore = useTripOverviewPageStore();

function toggleAccommodation(): void {
  const isDisabled = true;
  statsigEventsStore.logTripOverviewHotelToggle(isDisabled);

  tripOverviewPageStore.addAccommodationToOwnStayIngredient(
    props.segment.context.ingredientId
  );
}
</script>

<template>
  <ItineraryTimeline
    :segment-type="props.segment.segmentType"
    class="itinerary-own-stay-segment"
  >
    <template #dropdown>
      <AccommodationSelector
        selected-option="noAccommodation"
        :disabled="false"
        class="accommodation-selector"
        @toggle-accommodation="toggleAccommodation"
      />
    </template>

    <template #content>
      <AddHotelBanner :ingredient-id="props.segment.context.ingredientId" />
    </template>
  </ItineraryTimeline>
</template>

<style scoped lang="scss">
.link-text-own-stay {
  text-decoration: underline;
}
</style>
